import { Avatar, Box, Button, Collapse, IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import { FrontHand } from '@mui/icons-material'
import { useParams } from 'react-router-dom'
import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { toast } from 'react-toastify'

import { getNameInitials, Icons, USER_CARD_COLOR_SETS } from '../../../utils/utilities'
import { useSocketsContext } from '../../../contexts/sockets.context'
import { useMeetingStore } from '../../../store/meeting.store'
import OnlineUsersListCard from '../OnlineUsersListCard'
import { useUserStore } from '../../../store/user.store'
import { useOnlineSessionsSocketStore } from '../../../store/onlinesessionsocket.store'
import { getTransformedMeetingType } from '../../../utils/meeting-utilities'

const Participants = observer( ( { setShowEditAccessDialog } ) => {


    const [showContributors, setShowContributors] = useState( true )
    const [showRaisedHands, setShowRaisedHands] = useState( true )

    const { palette, border } = useTheme()
    // const { socket, emitEvent } = useSocketsContext()
    const { meeting_id } = useParams()

    const OnlineSessionSocketStore = useOnlineSessionsSocketStore()
    const MeetingStore = useMeetingStore()
    const UserStore = useUserStore()

    const openParticipantsSettings = () => {
        const openFlag = !['meeting settings', 'webinar settings', 'class settings'].includes( MeetingStore.getMeetingRoomLayoutSettings.leftSideCollapseTab )
        MeetingStore.setMeetingRoomLayoutSettings( {
            leftSideCollapseTab: `${MeetingStore.getCurrentMeeting.meeting_type === 'discussion' ? "meeting" : MeetingStore.getCurrentMeeting.meeting_type} settings`,
            isLeftSideCollapseOpen: openFlag
        } )
    }

    const revokeUserPermissions = async ( type = "allAccess" ) => {
        try {
            let newValue = { ...MeetingStore.getUsersPermissions }
            if ( type === "allAccess" ) {
                newValue = {}
            } else {
                for ( const userId in newValue ) {
                    if ( !Object.hasOwn( newValue, userId ) ) continue
                    const permissions = newValue[userId]

                    permissions[type] = false
                    console.log( "New Permission", permissions )
                }
            }

            const { success, message } = await OnlineSessionSocketStore.emit( 'meeting:updated-user-permissions', { room_id: meeting_id, newValue, user_id: null } )

            if ( success ) {
                MeetingStore.updateUsersPermissions( null, newValue )
            }
            if ( message )
                toast( message )
        } catch ( err ) {
            console.log( err )

        }

    }

    const lowerHand = async user => {
        const { success, message } = await OnlineSessionSocketStore.emit( "handraises:lower-user-hand", { room_id: meeting_id, user_id: user.user_id } )
        if ( success ) {
            if ( user.user_id === MeetingStore.getLocalUser.user_id )
                MeetingStore.setMeetingState( { raisedHand: false } )
        } else if ( message ) {
            toast( message )
        }
    }

    return (
        <Box overflow="auto" className="custom-scrollbar">
            <Box padding="10px" className="custom-scrollbar" overflow="auto">

                {MeetingStore.getCurrentMeeting?.meeting_settings?.access_type !== "ANY_ONE_CAN_JOIN" && MeetingStore.getCurrentMeeting.created_by === UserStore?.getUser.user_id && <Box marginBottom="10px">
                    <Button fullWidth onClick={() => setShowEditAccessDialog( true )} startIcon={Icons.default.PersonAdd} disableElevation sx={{ borderRadius: "20px" }} variant='outlined' > Manage Who can Join This Session </Button>
                </Box>}



                {MeetingStore.getLocalUser.meeting_role === "meeting-host" && Object.keys( MeetingStore.getUsersPermissions ).length > 0 && <Box sx={{ borderRadius: 5, border: border[1], p: 1, mb: 1, bgcolor: palette.action.hover }} >
                    <Typography variant='subtitle2' fontSize="12px" display="block" >{`${Object.keys( MeetingStore.getUsersPermissions ).length} participant${Object.keys( MeetingStore.getUsersPermissions ).length > 1 ? "s" : ""} have access to audio, video, or screen sharing.`}</Typography>
                    <Box display="flex" gap="5px" flexWrap="wrap" justifyContent="flex-end" alignItems="center">
                        <Tooltip onClick={() => revokeUserPermissions( "mic" )} disableInteractive placement='top' title="Revoke all mic access">
                            <IconButton size="small">
                                {Icons.default.MicOff}
                            </IconButton>
                        </Tooltip>
                        <Tooltip onClick={() => revokeUserPermissions( "camera" )} disableInteractive placement='top' title="Revoke all camera access">
                            <IconButton size="small">
                                {Icons.default.VideocamOff}
                            </IconButton>
                        </Tooltip>
                        <Tooltip onClick={() => revokeUserPermissions( "screenSharing" )} disableInteractive placement='top' title="Revoke all screen share access">
                            <IconButton size="small">
                                {Icons.default.CancelPresentation}
                            </IconButton>
                        </Tooltip>
                        <Button sx={{ borderRadius: 5 }} size='small' onClick={() => revokeUserPermissions()} color='secondary' variant='contained' disableElevation>
                            Revoke All Access
                        </Button>
                    </Box>
                </Box>}

                {MeetingStore.getCurrentMeeting?.hosts?.find( u => u.user_id === MeetingStore.getLocalUser.user_id ) && (
                    <Box sx={{ borderRadius: 5, border: border[1], p: 1, mb: 1, bgcolor: palette.action.hover }}>
                        <Typography variant="subtitle2" sx={{ fontSize: "1rem" }}> Media Permissions for Everyone </Typography>

                        <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                            Allow or block microphone, camera, and screen sharing for all participants at once.
                            These settings apply to the entire {getTransformedMeetingType( MeetingStore.getCurrentMeeting.meeting_type, { forDisplay: true } )}.
                        </Typography>

                        <Button
                            disableElevation
                            onClick={openParticipantsSettings}
                            size="small"
                            variant="contained"
                            sx={{ mt: 1, borderRadius: 5 }}
                            startIcon={Icons.default.ManageAccounts}
                        >
                            Manage Media Permissions
                        </Button>
                    </Box>
                )}

                <Typography fontSize="12px" fontWeight={700} letterSpacing="0.1em" gutterBottom paddingX="10px" color='GrayText'>IN MEETING</Typography>

                {MeetingStore.getRaisedHands.length > 0 && <Box marginBottom="20px" overflow="clip" border={border[1]} borderColor={palette.text.secondary} borderRadius="10px">
                    <Box padding="5px 20px" onClick={() => setShowRaisedHands( prev => !prev )} alignItems="center" display="flex" justifyContent="space-between" borderBottom={showContributors && border[1]} borderColor={palette.text.secondary} sx={{ cursor: "pointer", ":hover": { bgcolor: palette.rowHover } }}>
                        <Typography variant='subtitle2'>Raised Hands</Typography>
                        <Box display="flex" gap="10px" alignItems="center">
                            <Typography variant='subtitle2'>{MeetingStore.getRaisedHands.length}</Typography>
                            <IconButton size='small'>{showRaisedHands ? Icons.small.KeyboardArrowUp : Icons.small.KeyboardArrowDown}</IconButton>
                        </Box>
                    </Box>
                    <Collapse in={showRaisedHands} >
                        <Box maxHeight="300px" overflow="auto">
                            {MeetingStore.getRaisedHands?.map( ( user, index ) => {
                                const userName = user.name || MeetingStore.getMeetingUsersDetails[user.user_id].name || MeetingStore.getMeetingUsersDetails[user.user_id].email || user.user_id
                                return (
                                    <Box key={user.user_id} display="flex" justifyContent="space-between" alignItems="center" gap="10px" padding="10px">
                                        <Box minWidth={0} display="flex" width="100%" alignItems="center" gap="10px">
                                            <Typography flexShrink={0} variant='subtitle2' border={border[1]} width="25px" textAlign="center" display="flex" alignItems="center" justifyContent="center" borderRadius="50%" sx={{ aspectRatio: "1 / 1" }} >
                                                {index + 1}
                                            </Typography>
                                            <Avatar sx={{ width: "30px", height: "30px", fontSize: "12px", textTransform: "uppercase", background: USER_CARD_COLOR_SETS[user.color_index || 0].primary, color: palette.common.white }} >{getNameInitials( userName )}</Avatar>
                                            <Box flexGrow={1} overflow="hidden">
                                                <Tooltip disableInteractive placement='top' title={userName}>
                                                    <Typography fontSize="14px" fontWeight="500" noWrap >{userName} </Typography>
                                                </Tooltip>
                                            </Box>
                                        </Box>
                                        {MeetingStore.getCurrentMeeting.hosts.find( h => h.user_id === MeetingStore.getLocalUser.user_id ) && <Tooltip placement='top' disableInteractive title="Lower hand" >
                                            <IconButton onClick={() => lowerHand( user )} sx={{
                                                flexShrink: 0,
                                                "&:hover .lower-hands-icon": {
                                                    transform: `translateY(4px)`,
                                                    transformOrigin: "center center"
                                                }
                                            }} size='small' >
                                                <FrontHand className="lower-hands-icon" sx={{
                                                    fontSize: "20px",
                                                    transition: "transform 300ms ease"
                                                }} />
                                            </IconButton>
                                        </Tooltip>}
                                    </Box>
                                )
                            }
                            )}
                        </Box>
                    </Collapse>
                </Box>}



                <Box overflow="clip" border={border[1]} borderColor={palette.text.secondary} borderRadius="10px">
                    <Box padding="5px 20px" onClick={() => setShowContributors( prev => !prev )} alignItems="center" display="flex" justifyContent="space-between" borderBottom={showContributors ? border[1] : "none"} borderColor={palette.text.secondary} sx={{ cursor: "pointer", ":hover": { bgcolor: palette.rowHover } }}>
                        <Typography variant='subtitle2'>Contributors</Typography>
                        <Box display="flex" gap="10px" alignItems="center">
                            <Typography variant='subtitle2'>{MeetingStore.getRemoteUsers.length + 1}</Typography>
                            <IconButton size='small'>{showContributors ? Icons.small.KeyboardArrowUp : Icons.small.KeyboardArrowDown}</IconButton>
                        </Box>
                    </Box>
                    <Collapse in={showContributors} >
                        <Box maxHeight="500px" overflow="auto">
                            <Box display="flex" alignItems="center" padding="10px" justifyContent="space-between" gap="10px">
                                <Box display="flex" width="100%" alignItems="center" gap="10px">
                                    <Avatar sx={{ width: "30px", fontSize: "12px", height: "30px", background: USER_CARD_COLOR_SETS[MeetingStore.getLocalUser.color_index || 4].primary, color: palette.common.white }} >{getNameInitials( MeetingStore.getLocalUser?.name )}</Avatar>
                                    <Box flexGrow={1} overflow="hidden">
                                        <Tooltip disableInteractive placement='top' title={`${MeetingStore.getLocalUser?.name} (You)`}>
                                            <Typography width="100%" fontSize="14px" fontWeight="500" noWrap >{MeetingStore.getLocalUser?.name} (You)</Typography>
                                        </Tooltip>
                                        <Typography marginTop="-3px" fontSize="12px" display="block" textTransform="capitalize" >
                                            <Typography component="span" color='textSecondary' fontSize="10px" fontWeight={400} borderRadius="2px">{MeetingStore.getLocalUser?.meeting_role?.toLowerCase()?.replace( /[^a-zA-Z0-9]/, ' ' )}</Typography>
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                            {MeetingStore.getRemoteUsers?.map( user => (
                                <OnlineUsersListCard key={user.user_id} user={user} />
                            ) )}
                        </Box>
                    </Collapse>
                </Box>
            </Box>
        </Box>
    )
} )

export default Participants
